import { ShieldAlert } from 'lucide-react';

export const MissingCompanyContext = () => {
  return (
    <div className="flex h-64 items-center justify-center">
      <div className="max-w-md rounded-2xl border border-amber-200 bg-amber-50 p-6 text-center">
        <ShieldAlert className="mx-auto mb-4 text-amber-600" size={40} />
        <h2 className="text-lg font-semibold text-black">
          Company context missing
        </h2>
        <p className="mt-2 text-sm text-gray-700">
          The signed-in account does not have company details loaded yet.
        </p>
      </div>
    </div>
  );
};
